import { Tooltip } from 'antd';
import { TooltipPlacement } from 'antd/lib/tooltip';

const TooltipComponent = ({
    title,
    children,
    arrowPointAtCenter = false,
    placement = 'topLeft',
    textTransform,
}: {
    title: string;
    children: React.ReactNode;
    arrowPointAtCenter?: boolean;
    placement?: TooltipPlacement;
    textTransform?: React.CSSProperties['textTransform'];
}): JSX.Element => {
    return (
        <Tooltip
            placement={placement}
            title={title}
            destroyTooltipOnHide={true}
            arrowPointAtCenter={arrowPointAtCenter}
            overlayInnerStyle={{
                textTransform: textTransform,
                backgroundColor: '#394452',
                borderRadius: 4,
                fontFamily: 'lato',
                fontSize: 12,
                fontWeight: 400,
                padding: 8,
                // width: 12,
            }}
        >
            {children}
        </Tooltip>
    );
};

export default TooltipComponent;
